import script from "./blocked-port-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./blocked-port-list.vue?vue&type=script&setup=true&lang=ts"

import "./blocked-port-list.vue?vue&type=style&index=0&id=2307306e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2307306e"]])

export default __exports__